import axios from 'axios'
import { ref } from 'vue'
// import Cookies from "vue-cookies";

const instance = axios.create({
  baseURL: process.env.VUE_APP_LMS_URL,
})

// OTP코드 발송해주는 API 마스킹, 전체 공통사용
// eslint-disable-next-line consistent-return
export async function sendOtpNumber(type, username, val) {
  // const datas = {}
  // console.log(type)
  // console.log(username)
  // console.log(val)
  try {
    if (type === 'sms') {
      const datas = { name: username, phone: val }
      // console.log(datas)
      const sendOTP = await instance.post(
        `/api/v1/member/auth/find/id/${type}/otp`,
        datas
      )
      // console.log(sendOTP)
      return sendOTP.data
    }
    if (type === 'email') {
      const datas = { name: username, email: val }
      // console.log(datas)
      const sendOTP = await instance.post(
        `/api/v1/member/auth/find/id/${type}/otp`,
        datas
      )
      // console.log(sendOTP)
      return sendOTP.data
    }
  } catch (err) {
    console.log(err)
    return err.response.data
  }
  // type은 이메일인지 문자인지 체크하는 값
  // val 사용자의 이메일 또는 핸드폰 번호 값
  // console.log(type)
  // console.log(val)
  // try {
  //   if (type === 'sms') {
  //     const sendOTP = await instance.post(
  //       `/api/v1/member/auth/find/otp/${type}`,
  //       `/api/v1/member/auth/find/otp/${type}`,
  //       { value: val }
  //     )
  //     return sendOTP.data
  //   }
  //   if (type === 'email') {
  //     const sendOTP = await instance.post(
  //       `/api/v1/member/auth/find/otp/${type}`,
  //       { value: val }
  //     )
  //     console.log(sendOTP)
  //     return sendOTP.data
  //   }
  // } catch (err) {
  //   console.log(err)
  //   return err.response.data
  // }
}

// 마스킹된 ID를 찾기 위해 정보를 API로 전송
// eslint-disable-next-line camelcase
export async function letFindIdMasking(name, phone, email, otp_code) {
  let datas = ''
  // console.log('타입이 들어가는지 확인')
  // console.log(name)
  // console.log(phone)
  // console.log(email)
  // console.log(otp_code)
  const type = ref('')
  if (phone && !email) {
    // eslint-disable-next-line camelcase
    datas = { name, phone, otp_code }
    type.value = 'sms'
    // console.log('datas >>> ', datas)
    // console.log(type.value)
  } else if (email && !phone) {
    // eslint-disable-next-line camelcase
    datas = { name, email, otp_code }
    type.value = 'email'
    // console.log(type.value)
    // console.log('datas >>> ', datas)
  }
  try {
    const findId = await instance.post(
      `/api/v1/member/auth/find/id/${type.value}`,
      datas
    )
    // if (findId.data.code === 'MB21000200') {
    if (findId.data.code === 'MB21100200') {
      // Cookies.set('originalID', findId.data.content.userid);
      // Cookies.set('joinDate', findId.data.content.created_at);
      localStorage.setItem('firstStap', 'passfSitnIdc')
      localStorage.setItem('originalID', findId.data.content.userid)
      localStorage.setItem('joinDate', findId.data.content.created_at)
      return findId.data
    }
    return findId.data
  } catch (err) {
    console.log(err)
    console.log(err.response.data)
    return err.response.data
    // return err.response.data
  }
}

// 전체 ID를 찾기 위해 API로 데이터 전송
// eslint-disable-next-line consistent-return, camelcase
export async function letFindIDAll(name, phone, email, otp_code) {
  let datas = ''
  // console.log('타입이 들어가는지 확인')
  // console.log(name)
  // console.log(phone)
  // console.log(email)
  // console.log(otp_code)
  const type = ref('')
  if (phone && !email) {
    // eslint-disable-next-line camelcase
    datas = { name, phone, otp_code }
    type.value = 'sms'
    console.log('datas >>> ', datas)
    console.log(type.value)
  } else if (email && !phone) {
    // eslint-disable-next-line camelcase
    datas = { name, email, otp_code }
    type.value = 'email'
    console.log(type.value)
    console.log('datas >>> ', datas)
  }
  try {
    const findId = await instance.post(
      `/api/v1/member/auth/find/id/${type.value}`,
      datas
    )
    // if (findId.data.code === 'MB21000200') {
    if (findId.data.code === 'MB21100200') {
      // Cookies.set('originalID', findId.data.content.userid);
      // Cookies.set('joinDate', findId.data.content.created_at);
      localStorage.setItem('firstStap', 'passfSitnIdc')
      localStorage.setItem('originalID', findId.data.content.userid)
      localStorage.setItem('joinDate', findId.data.content.created_at)
      return findId.data
    }
    return findId.data
  } catch (err) {
    console.log(err)
    console.log(err.response.data)
    return err.response.data
    // return err.response.data
  }
}
// export async function letFindIDAll(type, HPval, Emailval, HPotp, Emailotp) {
//   // type은 이메일인지 문자인지 체크하는 값
//   // HPval, Emailval 사용자의 이메일(Emailval) 또는 핸드폰 번호(HPval) 값
//   // HPotp, Emailotp 인증번호 값

//   try {
//     if (type === 'sms' || type === '') {
//       const datas = { value: HPval, code: HPotp }
//       const checkOTP = await instance.post(
//         `/api/v1/member/auth/find/otp/${type}/verify`,
//         datas
//       )
//       return checkOTP.data
//     }
//     if (type === 'email') {
//       const datas = { value: Emailval, code: Emailotp }
//       const checkOTP = await instance.post(
//         `/api/v1/member/auth/find/otp/${type}/verify`,
//         datas
//       )
//       return checkOTP.data
//     }
//   } catch (err) {
//     // console.log(err);
//   }
// }

// PW찾기 : 메일 발송 부분
export async function sendEmailForPW(userID, name, email) {
  // console.log("PW를 찾기 위한 이메일 발송")
  try {
    const datas = { userid: userID, name, email }
    const sendEmail = await instance.post(`/api/v1/member/auth/find/pwd`, datas)
    console.log(sendEmail.data)
    return sendEmail.data
  } catch (err) {
    console.log(err.response.data)
    return err.response.data
  }
}

// PW찾기 : 메일로 진입 후 PW변경
// 오류일때도 테스트 해야함
export async function changePWPage(info, token) {
  try {
    const params = { info, token }
    const loadCahangePage = await instance.get(`/api/v1/member/auth/find/pwd`, {
      params,
    })
    return loadCahangePage.data
  } catch (err) {
    return err.response.data
  }
}

export async function changePW(token, newpw, newpwchk) {
  // console.log(token)
  // console.log(newpw)
  // console.log(newpwchk)
  try {
    const datas = { token, new_pwd: newpw, new_pwd_confirm: newpwchk }
    const changePWRes = await instance.put(
      `/api/v1/member/auth/find/pwd`,
      datas
    )
    return changePWRes.data
  } catch (err) {
    return err.response.data
  }
}
